import { JSX } from "react";

const ProvidersBySpecialtyDescription = (): JSX.Element => {
  return <>
    <p>
      The Providers By Specialty card shows how your network is distributed across different provider specialty codes and helps you understand which specialties make up the largest and smallest portions of your network.
    </p>
    <p>
      Providers with a specialty code not included in the Adequacy template will be grouped as “Unknown.”
    </p>
  </>;
}

export { ProvidersBySpecialtyDescription };